import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { PrefsEmailTestComponent } from "./prefs-email-test/prefs-email-test.component";
import { PrefsSchoolTableComponent } from "./prefs-school-table/prefs-school-table.component";
import { DataService_AdvancedPreferences } from "./shared/data.service";
import { PreferenceRequestModel } from "./shared/PreferenceRequestModel";

@Component({
	selector: "app-advanced-preferences",
	templateUrl: "./advanced-preferences.component.html",
	styleUrls: ["./advanced-preferences.component.css"],
})
export class AdvancedPreferencesComponent implements OnInit {
	constructor(
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private advancedPreferencesService: DataService_AdvancedPreferences
	) {}

	ngOnInit(): void {
		this.loadBaseURL();
	}

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////
	@ViewChild(PrefsSchoolTableComponent)
	SchoolRef: PrefsSchoolTableComponent;

	//Form
	Category: any = "";
	KeyName: any = "";
	KeyValue: any = "";

	SchoolOption: any = "School";

	errorMessage: any = "";

	processing: any = false;

	LoadingBaseURL: any = true;
	BaseURL: any = "";

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////

	loadBaseURL() {
		this.LoadingBaseURL = true;

		var result = this.advancedPreferencesService.BaseURLSelect();
		result.subscribe(
			(response: any) => {
				this.LoadingBaseURL = false;

				if (response.length > 0) {
					this.BaseURL = response[0];
				}
			},
			(error) => {
				this.LoadingBaseURL = false;
			}
		);
	}

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////
	onSendEmail() {
		var ref = this.dialogService.open(PrefsEmailTestComponent, {
			header: "Send Email",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	onAddPref() {
		this.errorMessage = "";

		//Error handling

		if (this.SchoolOption == "School" && this.SchoolRef.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to add a preference to";
			return;
		}

		if (this.Category == "") {
			this.errorMessage = "Select a Category";
			return;
		}

		if (this.KeyName == "") {
			this.errorMessage = "Select a Key Name";
			return;
		}

		//Create request
		this.processing = true;

		let lstSchoolIDs: number[] = [];

		if (this.SchoolOption == "School") {
			for (var i = 0; i < this.SchoolRef.SelectedSchools.length; i++) {
				var next = this.SchoolRef.SelectedSchools[i];

				lstSchoolIDs = [...lstSchoolIDs, next.SchoolID];
			}
		} else {
			lstSchoolIDs = [...lstSchoolIDs, -1]; //District
		}

		let AddPrefRequest: PreferenceRequestModel = {
			Category: this.Category,
			KeyName: this.KeyName,
			KeyValue: this.KeyValue,
			SchoolIDs: lstSchoolIDs,
		};

		//Call SP
		var result = this.advancedPreferencesService.AddPreference(AddPrefRequest);
		result.subscribe(
			(response) => {
				this.processing = false;

				var lstSkipped: any = response;

				if (lstSkipped.length == 0) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Preference was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SchoolRef.SelectedSchools = [];
						},
					});
				}
				//No Error but schools were skipped:
				else if (lstSkipped[0].SchoolID != -1) {
					var MSG = "<p>Preference was added successfully. These schools were skipped: </br>";

					for (var i = 0; i < lstSkipped.length; i++) {
						var next = lstSkipped[i];

						MSG += "[" + next.SchoolNumber + "] - " + next.SchoolName + "</br>";
					}

					MSG += "</p>";

					if (lstSkipped.length == lstSchoolIDs.length) {
						MSG +=
							"<p>All selected schools already have the preference. </br>To edit the preference go to Preference Settings and SU Only Preferences</p>";
					}

					//Success Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SchoolRef.SelectedSchools = [];
						},
					});
				}
				//Error
				else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Preference",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClear() {
		this.SchoolRef.SelectedSchools = [];
	}

	onClearForm() {
		this.Category = "";
		this.KeyName = "";
		this.KeyValue = "";
	}
	///////////////////////////////////////////
}
